import { useEffect, useRef, useState } from "react";
import { useSidebar } from "../../contexts/sidebar-context";
import DropdownUser from "../Header/DropdownUser";
import { Hamburger, Menu } from "lucide-react";

const AppHeader: React.FC = () => {
  const [isApplicationMenuOpen, setApplicationMenuOpen] = useState(false);

  const { isMobileOpen, isExpanded, isHovered, toggleSidebar, toggleMobileSidebar } = useSidebar();

  const handleToggle = () => {
    if (window.innerWidth >= 1024) {
      toggleSidebar();
    } else {
      toggleMobileSidebar();
    }
  };

  const toggleApplicationMenu = () => {
    setApplicationMenuOpen(!isApplicationMenuOpen);
  };

  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key === "k") {
        event.preventDefault();
        inputRef.current?.focus();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <header className={`fixed top-0 right-0 bg-primary-lighter z-50 transition-all duration-300 ease-in-out ${isExpanded || isHovered ? "lg:left-[220px]" : "lg:left-[70px]"} left-0`}>
        <div className="p-2.5 flex w-full justify-between">
          <button
            className="items-center justify-center w-8 h-8 text-white border-gray-200 rounded-lg z-99999 lg:flex lg:h-9 lg:w-9 lg:border"
            onClick={handleToggle}
            aria-label="Toggle Sidebar"
          >
            <Menu className="w-5 h-5" />
          </button>
          <DropdownUser />
        </div>
    </header>
  );
};

export default AppHeader;
